export const PIX: Pix = {
  pixKeys: [
    {
      key: '655f9eba-ae08-4f5e-8a24-c0306b336f80',
      keyType: 'EVP',
      wasCreatedNow: true,
    },
    {
      keyType: 'CPF',
      key: '52998224725',
    },
    {
      keyType: 'CNPJ',
      key: '12ABC34501DE35',
    },
  ],
}
